import React, { useMemo } from 'react';
import { DNABox, DNAButton, DNAText } from '@alucio/lux-ui';
import folderQuery from 'src/state/redux/folder/query';
import { useAllFoldersUpdatedDocsMap } from 'src/state/redux/selector/folder';
import { useHistory } from 'src/router';
import WidgetContainer from '../WidgetContainer';
import withPermissionsAccessControl from 'src/hooks/useFeatureFlags/withPermissionsAccessControl';

const MyUpdatesBase: React.FC = () => {
  const history = useHistory();
  const currentActiveFilter = useMemo(() => folderQuery.merge(folderQuery.filters.active), []);
  const updatedDocumentsMap = useAllFoldersUpdatedDocsMap(currentActiveFilter);

  const updatedItemsCount = useMemo(() => {
    let updatedItems = 0;
    updatedDocumentsMap.forEach((items) => {
      updatedItems += items.length;
    });
    return updatedItems;
  }, [updatedDocumentsMap]);

  const widgetMessage = useMemo(() =>
    updatedItemsCount === 1
      ? 'You have an item that needs to be reviewed.'
      : `You have ${updatedItemsCount} items that need to be reviewed.`, [updatedItemsCount]);

  const redirectToMyUpdatesPage = () => {
    history.push('/folders/updates')
  };

  if (!updatedItemsCount) return null;
  return (
    <WidgetContainer title="My Updates" actionsCount={updatedItemsCount}>
      <DNABox fill appearance="col" spacing="md">
        <DNAText status="secondary">
          {widgetMessage}
        </DNAText>
        <DNAButton
          appearance="outline"
          onPress={redirectToMyUpdatesPage}
          children="View updates"
        />
      </DNABox>
    </WidgetContainer>
  );
};

const MyUpdates = withPermissionsAccessControl(MyUpdatesBase, {
  flags: ['enableHomeMyUpdatesWidget'],
});

export default MyUpdates;
